// 可领取优惠券列表
<template>
  <div class="get-coupon-box" v-if="couponList.length">
    <div class="left-label-icon">
      <img src="../assets/coupon/coupon-tag.png" class="icon" />
    </div>
    <!-- list -->
    <div
      class="coupon-list"
      :class="{ 'item-has-margin': couponList.length > 20 }"
    >
      <div class="item" v-for="(item, index) in couponList" :key="index">
        <span class="bg-left bg-coupon-border"></span>
        <span class="item-text">
          <template >
            满{{  item.UseRequire.GoodsLimitPrice ? item.UseRequire.GoodsLimitPrice : item.UseRequire.GoodsLimitNumber }}{{ item.DeductionMode === 1 ? '减' :'享'}}
            <span v-if="item.DeductionMode != 3">
              {{
              item.DeductionMode === 1 ? item.DeductionLimit : item.discountNum
              }}
            </span>
             {{ item.DeductionMode === 1 ? '' :'折'}}
          </template>
        </span>
        <span class="bg-right bg-coupon-border"></span>
      </div>
    </div>
    <!-- to-coupon-center -->
    <div class="to-link-box" @click.stop="toCouponCenter" v-if="showLink">
      <span>去领券</span><van-icon name="arrow" color="#111A34" />
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base'
export default {
  name: '',
  mixins: [],
  components: {},
  // 页面数据部分
  props: {
    showLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      LinkTypeCode,
      couponList: [],
    }
  },
  computed: {},
  watch: {},
  // 页面生命周期
  created() {},
  mounted() {
    this.getCoupons();
  },
  unmounted() {},
  // 页面内方法
  methods: {
    toCouponCenter() {
      try {
        const toUrl = this.$router.resolve('/VoucherCenter')
        window.open(toUrl.href, '_blank')
      } catch (e) {}
    },
    // 获取当前可领取优惠券列表
    async getCoupons() {
      const res = await this.getAction('/api_coupon/Coupon/GetCoupons', {
        goodsId: '',
      })
      if (res.IsSuccess && res.Data) {
        let couponsArr = []
        for (let index = 0; index < res.Data.length; index++) {
          const item = res.Data[index]
          if (item.OutCouponDto.IsReceive && !item.OutCouponDto.IsUse) {
            // 退出已领取
            continue
          } else {
            const showDiscountNum = parseFloat(
              item.OutCouponDto.OutCouponIssueDto.DeductionLimit * 10
            )
            let lrt = showDiscountNum >= 1 ? showDiscountNum.toFixed(0) : showDiscountNum.toFixed(1)
            let l = {
              ...item,
              IsReceive: item.OutCouponDto.IsReceive,
              IsUse: item.OutCouponDto.IsUse,
              Goods:
                item.OutCouponDto.OutCouponIssueDto.OutCouponLimitGoodsDtos,
              UseRequire:
                item.OutCouponDto.OutCouponIssueDto.OutCouponUseRequireDto,
              DeductionMode: item.OutCouponDto.OutCouponIssueDto.DeductionMode, //指定金额1，指定比例2，全额抵扣3
              DeductionLimit:
                item.OutCouponDto.OutCouponIssueDto.DeductionLimit,

              discountNum:lrt,
              loading: false,
            }
            couponsArr.push(l)
          }
        }
        // 取前三个
        const filterData = couponsArr.splice(0, 3)
        this.couponList = couponsArr
        // console.log(this.couponList)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.get-coupon-box {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .left-label-icon {
    padding-right: 20px;
    display: flex;
    align-items: center;
    .icon {
      width: 23px;
      height: 16px;
    }
  }
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    &.item-has-margin {
      .item {
        margin-bottom: 8px;
      }
    }
    .item {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #ff3939;
      margin-right: 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      span {
        display: block;
      }
      .item-text {
        background: url('../assets/coupon/content-bg.png') 0 0 no-repeat;
        background-size: 100% 100%;
        height: 17px;
        padding: 0 3px;
        line-height: 17px;
        display: flex;
      }
      .bg-coupon-border {
        content: '';
        width: 4px;
        height: 17px;
      }
      .bg-left {
        background: url('../assets/coupon/left-bg.png') 0 0 no-repeat;
        background-size: 100% 100%;
        // margin-right: -0.5px;
      }
      .bg-right {
        background: url('../assets/coupon/right-bg.png') 0 0 no-repeat;
        background-size: 100% 100%;
        //  margin-left: -0.5px;
      }
    }
  }
  // to-link-box
  .to-link-box {
    color: #111a34;
    font-size: 12px;
    flex: 0 0 48px;
    display: flex;
    align-items: center;
    margin-left: 4px;
    cursor: pointer;
    span {
      position: relative;
      top: -0.5px;
    }
  }
}
</style>
